module.exports = __webpack_public_path__ + "static/media/MY.ca0bd3c3.svg";